import { type CatalogPermissionSecondaryCategoryConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import { useCatalogPermissionSecondaryCategoryConfigListPresenter } from './useCatalogPermissionSecondaryCategoryConfigListPresenter'
import { CatalogPermissionSecondaryCategoryConfigTable } from '../../views/CatalogPermissionSecondaryCategoryConfigTable'

export interface ICatalogPermissionSecondaryCategoryConfigListPresenterProps {
  selectedSecondaryCategoryId: Nullable<number>
  onSelectSecondaryCategory: (
    secondaryCategory: CatalogPermissionSecondaryCategoryConfig
  ) => void
}

export const CatalogPermissionSecondaryCategoryConfigListPresenter = ({
  selectedSecondaryCategoryId,
  onSelectSecondaryCategory,
}: ICatalogPermissionSecondaryCategoryConfigListPresenterProps) => {
  const {
    data: { items, paging },
    states: { isLoading, isError, searchValue },
    commands: {
      handleSelectSecondaryCategory,
      handleSearchChange,
      handleSearchSubmit,
      handlePageChange,
    },
  } = useCatalogPermissionSecondaryCategoryConfigListPresenter({
    selectedSecondaryCategoryId,
    onSelectSecondaryCategory,
  })

  return (
    <CatalogPermissionSecondaryCategoryConfigTable
      items={items}
      selectedSecondaryCategoryId={selectedSecondaryCategoryId}
      onSelectSecondaryCategory={handleSelectSecondaryCategory}
      isLoading={isLoading}
      isError={isError}
      searchValue={searchValue}
      onSearchChange={handleSearchChange}
      onSearchSubmit={handleSearchSubmit}
      paging={paging}
      onPageChange={handlePageChange}
    />
  )
}

CatalogPermissionSecondaryCategoryConfigListPresenter.displayName =
  'CatalogPermissionSecondaryCategoryConfigListPresenter'
